(function (angular) {
	'use strict';

	angular
		.module('viewPlanModule')
		.controller('ViewPlan', [
			'DEFAULT_PRINCIPAL_OPTIONS',
			'globalConfig',
			'mixpanelFactory',
			'orderFormFactory',
			'planFactory',
			'PropertyService',
			'ReitElementFactory',
			'urlFactory',
			ViewPlanFunction
		]);

	function ViewPlanFunction(
		DEFAULT_PRINCIPAL_OPTIONS,
		globalConfig,
		mixpanelFactory,
		orderFormFactory,
		planFactory,
		PropertyService,
		ReitElementFactory,
		urlFactory) {
		
		var viewPlan = this;

		function findFeaturedReitElementsInList(list) {
			angular.forEach(list, function(reitElement) {
				if(viewPlan.featuredReitElementIds.indexOf(parseInt(reitElement.id)) >= 0) {
					viewPlan.featuredIdstoReitElements[reitElement.id] = reitElement;
				}
			});
		}

		function setStrategy() {
			if(viewPlan.goal === 'Balanced Investing') {
				viewPlan.showToggle = true;
				viewPlan.selectedStrategy = 'Supplemental Income';
			} else {
				viewPlan.selectedStrategy = viewPlan.goal;
			}
		}

		viewPlan.$onInit = function() {
			angular.extend(viewPlan, globalConfig);
			viewPlan.featuredIdstoReitElements = {};
			//first element is featured, but design wants it to be the middle element
			viewPlan.planFeaturedReitElementId = viewPlan.featuredReitElementIds[0];
			viewPlan.featuredReitElementIds[0] = viewPlan.featuredReitElementIds[1];
			viewPlan.featuredReitElementIds[1] = viewPlan.planFeaturedReitElementId;

			viewPlan.amount = DEFAULT_PRINCIPAL_OPTIONS[2];

			viewPlan.navItems = [
				{
					label: 'Overview',
					value: 'overview'
				}, {
					label: 'Return Profile',
					value: 'return-profile'
				}, {
					label: 'Strategy',
					value: 'strategy'
				}, {
					label: 'Featured Asset',
					value: 'featured-asset'
				}, {
					label: 'Portfolio',
					value: 'portfolio'
				}, {
					label: 'Top Questions',
					value: 'top-questions'
				}
			];

			planFactory.getPlanData(globalConfig.riaPlanTypes).then(function (response) {
				angular.forEach(response.data, function (plan) {
					if (plan.planId === globalConfig.riaPlanId) {
						viewPlan.planData = plan;
						viewPlan.goal = plan.name;
						setStrategy();
						viewPlan.planDataArr = [viewPlan.planData];
					}
				});
			});

			ReitElementFactory.getReitElementListsForPlan(globalConfig.riaPlanId).then(function (reitElementLists) {
				angular.extend(viewPlan, reitElementLists);
				viewPlan.featuredReitElements = [];
				findFeaturedReitElementsInList(viewPlan.flatReitElementListByStatus.active);
				findFeaturedReitElementsInList(viewPlan.flatReitElementListByStatus.redeemed);
				angular.forEach(viewPlan.featuredReitElementIds, function (reitElementId) {
					if (angular.isDefined(viewPlan.featuredIdstoReitElements[reitElementId])) {
						viewPlan.featuredReitElements.push(viewPlan.featuredIdstoReitElements[reitElementId]);
					}
				});
			});
		};

		viewPlan.clickNav = function(item) {
			mixpanelFactory.track('Plan Details Nav Clicked', {
				planName: viewPlan.goal,
				navItem: item.value
			});
		};

		viewPlan.changeStrategy = function() {
			if(viewPlan.selectedStrategy === 'Supplemental Income') {
				viewPlan.selectedStrategy = 'Long-Term Growth';
			} else {
				viewPlan.selectedStrategy = 'Supplemental Income';
			}
			
			mixpanelFactory.track('Change Strategy', {
				'Selected': viewPlan.selectedStrategy
			});
		};
		
		viewPlan.submitOrderForm = function(planId) {
			orderFormFactory.submitOrderForm(planId).then(function(){
				urlFactory.redirect('/reits/signup-checkout/signup');
			});
		};
	}
})(window.angular);